import * as actionsType from "../actions/types";

const initialState = {
    isLoggedIn: false,
    user: {}
  };

export default function userReducer(state=initialState, action) {
    switch(action.type) {
        case actionsType.LOGIN_SUCCESS:
            // alert("login_success")
            return {...state,isLoggedIn: true,user: action.payload };

            case actionsType.LOGOUT_SUCCESS:
                console.log("Initial State on logout", initialState)
                return { ...initialState };
    
                case actionsType.REGISTER:
                    return {...state,user:action.payload.user,data:action.payload.data, };
        default:
            return state;
    }


}


  